export default __webpack_public_path__ + "static/media/svg3.9f809239.svg";